import { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  CardTitle,
  Form,
  FormGroup,
  Card,
  CardHeader,
  CardBody,
  Button,
  ModalFooter,
} from "reactstrap";
import Select from "react-select";
import { GetAdminCourses, GetOrphanCourses } from "../../actions/adminQueries";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage, useIntl } from "react-intl";

export default function AddCourseToProgramLicenseModal(props) {
  const intl = useIntl();
  const [selectedCoursesToAdd, setSelectedCoursesToAdd] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [availabledCoursesToAdd, setAvailabledCoursesToAdd] = useState([]);
  const adminCourses = GetAdminCourses();
  const orphanCourses = GetOrphanCourses();
  const handleChange = (selected) => {
    setSelectedCoursesToAdd(selected);
  };

  useEffect(() => {
    if (!adminCourses.isPending && props.licenseId) {
      let tempAllCourses = [];
      (adminCourses.data ?? []).forEach((program) => {
        program.courses.forEach((course) => {
          if (!tempAllCourses.some((acc) => acc.id === course.id)) {
            tempAllCourses.push(course);
          }
        });
      });
      tempAllCourses.push(...(orphanCourses.data ?? []));
      setAllCourses(tempAllCourses);
    }
  }, [
    props.licenseId,
    adminCourses.data,
    orphanCourses.data,
    props.licenseName,
    adminCourses.isPending,
  ]);

  useEffect(() => {
    if (!adminCourses.isPending && props.licenseId) {
      let currentLicenseWithCourses = (adminCourses.data ?? []).filter(
        (lic) => lic.program.id === props.licenseId
      );
      let tempaAailabledCoursesToAdd = [];
      allCourses.forEach((course) => {
        if (
          !currentLicenseWithCourses[0]?.courses?.some((c) => c.id === course.id)
        ) {
          let selectObject = { label: course.name, value: course.id };
          tempaAailabledCoursesToAdd.push(selectObject);
        }
      });
      setAvailabledCoursesToAdd(tempaAailabledCoursesToAdd);
    }
  }, [allCourses, props.licenseId, adminCourses.isPending, adminCourses.data]);

  return (
    <Modal isOpen={props.isOpen} toggle={() => props.toggle(null, null)}>
      <ModalBody>
        <CardTitle>{props.licenseName}</CardTitle>

        <Card>
          <CardHeader>
            <FontAwesomeIcon icon="circle-plus" className="text-primary me-1" />
            <FormattedMessage id="ChooseExistingCourses" />
          </CardHeader>
          <CardBody>
            <Form>
              <FormGroup>
                <Select
                  placeholder={intl.formatMessage({ id: "ChooseCourses" })}
                  isMulti
                  noOptionsMessage={() =>
                    intl.formatMessage({ id: "AllCoursesAlreadyInProgramLicense" })
                  }
                  onChange={(selected) => handleChange(selected)}
                  options={availabledCoursesToAdd}
                />
              </FormGroup>
            </Form>
          </CardBody>
        </Card>
      </ModalBody>
      <ModalFooter>
        <Button
          outline
          color="secondary"
          onClick={() => props.toggle(null, null)}
        >
          <FormattedMessage id="Cancel" />
        </Button>
        <Button
          outline
          color="primary"
          disabled={selectedCoursesToAdd.length === 0 || props.posting}
          onClick={() => props.addCourses(selectedCoursesToAdd)}
        >
          {props.posting ? (
            <FormattedMessage id="AddingDotDotDot" />
          ) : (
            <FormattedMessage id="Add" />
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
